<template>
  <div style="text-align: center; margin-right: 10px">
    <Page
      transfer
      v-show="page"
      :current="page.current"
      :total="page.total"
      :page-size="page.size"
      :page-size-opts="[...pageArr,...pArr]"
      @on-change="handlerPage"
      @on-page-size-change="pageSizeChange"
      placement="top"
      :show-sizer="showSizer"
      show-total
    />
  </div>
</template>

<script>
export default {
  name: 'pages',
  props: {
    page: Object,
    func: {
      type: Function
    },
    pArr: {
      type:Array,
      default:()=>[]
    },
    showSizer: {
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
      pageArr: [10, 15, 20]
    }
  },
  methods: {
    handlerPage(page) {
      this.page.current = page
      this.func(page)
    },
    pageSizeChange(pageSize) {
      this.page.size = pageSize
      this.func()
    }
  }
}
</script>

<style lang="less" scoped></style>
